import { useCommonCodeStore } from "@/store/commonCodeStore";
import { useEquipStore } from "@/store/equipStore";
import { useEtcStore } from "@/store/etcStore";
import { useRouteStore } from "@/store/routeStore";
import { useSiteStore } from "@/store/siteStore";
import { useUserStore } from "@/store/userStore";
import { useTocStore } from "@/store/tocStore";
import { UserType } from '@/enums';
import Swal from "sweetalert2";
import { useDeviceStore } from "~/store/deviceStore";
import { useInstallerStore } from "~/store/installerStore";
import { useDynamicRouter } from "~/composables/useDynamicRouter";

export default defineNuxtRouteMiddleware(async (to, from) => {

	// alert(from.fullPath);

	const siteStore = useSiteStore();
	const userStore = useUserStore();

	const commonCodeStore = useCommonCodeStore();
	const routeStore = useRouteStore();
	const equipStore = useEquipStore();
	const etcStore = useEtcStore();
  const deviceStore = useDeviceStore();
	const installerStore = useInstallerStore();
	const tocStore = useTocStore();
	const { updateRouter, waitForRouteUpdate } = useDynamicRouter();


  deviceStore.setDevice();

  const route = useRoute();
	const router = useRouter();


	const ignoreURI = [
		"/toc/user/login"
	]
  
	const toLoginURI = [
		'/toc',
		'/toc/'
	]

  const deviceType = deviceStore.device; 
  // const deviceType = "isMobile"; 

	const {$invokeNative} = useNuxtApp();

	const isAutoLoginCheck = ref(process.client ? (window.localStorage.getItem("autoLogin") || 'false') : 'false');

	const tocAutoLogin = useCookie('tocAutoLogin');

  const userToken = useCookie("userToken");

	// alert(JSON.stringify(userToken));
	// alert(userToken.value);
	// alert(isAutoLoginCheck.value);
	// alert(useCookie('userToken'));

	const accessToken = userStore.apiTokenInfo?.accessToken;

  // userToken이 없으면 자동 로그인을 비활성화
  // if (!userToken.value) {
	// 	if (process.client) {
	// 		window.localStorage.setItem("autoLogin", "false");
	// 	}
	// 	isAutoLoginCheck.value = "false";
	// 	tocAutoLogin.value = "false";
	// }

		// if(to.fullPath.includes('toc/monitoring/newDashboard')){
		// 	alert('화면이 변경되었습니다. 다시 로그인해주세요.');
		// 	return navigateTo('/toc/user/login');
		// }

	if(to.fullPath === '/'){
		if(deviceType === 'isDesktop'){
			return navigateTo('/toc');
		} else if(deviceType === 'isMobile') {
			return navigateTo('/mobile');
		}
	}

	/**
	 * TOC 자동로그인 시도 함수
	 * @returns 자동로그인 성공 여부
	 */
	async function tryTocAutoLogin(): Promise<boolean> {
		try {
			await userStore.refreshToken();
			const result = userStore.apiTokenInfo;
			if(result?.userSeq) {
				// 자동로그인 성공 - 필요한 초기화 작업 수행
				await tocAutoLoginInit(result.userSeq);
				return true;
			}
			return false;
		} catch (error) {
			console.error('자동 로그인 실패:', error);
			// 토큰 갱신 실패 시 쿠키 초기화
			tocAutoLogin.value = 'false';
			return false;
		}
	}

	if(to.fullPath.includes('toc')){
		if(accessToken && userToken.value){
			userStore.isRefresh = false;
		}

		// 로그인 페이지 접근 시 처리
		if(ignoreURI.findIndex(v => v === to.fullPath) !== -1){
			// loginUserInfo가 없으면 로그인 페이지에 머무름 (로그아웃 상태)
			if(!userStore.loginUserInfo){
				return;
			}
			
			// 이미 로그인되어 있고 자동로그인이 활성화되어 있으면 대시보드로 리다이렉트
			if(Boolean(tocAutoLogin.value) === true && userToken.value && accessToken){
				// 이미 로그인된 상태이므로 대시보드로 이동
				return navigateTo('/toc/dashboard/default');
			}
			// 자동로그인 시도
			if(Boolean(tocAutoLogin.value) === true && userToken.value && !accessToken){
				const success = await tryTocAutoLogin();
				if(success) {
					// Owner 타입의 경우 tocAutoLoginInit 내부에서 네비게이션 처리됨
					// Manager/Admin 타입의 경우에만 대시보드로 이동
					if(userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin){
						return navigateTo('/toc/dashboard/default');
					}
					// Owner 타입의 경우 이미 네비게이션되었으므로 return
					return;
				}
				// 실패 시 로그인 페이지에 머무름
				return;
			}
			return;
		}

		// TOC 루트 경로 접근 시 자동로그인 처리
		if(toLoginURI.findIndex(v => v === to.fullPath) !== -1){
			if(Boolean(tocAutoLogin.value) === true){
				if(!accessToken){
					if(!userToken.value){
						// refreshToken이 없으면 로그인 페이지로 이동
						return navigateTo('/toc/user/login');
					} else {
						// refreshToken이 있으면 자동로그인 시도
						const success = await tryTocAutoLogin();
						if(success) {
							// Owner 타입의 경우 tocAutoLoginInit 내부에서 네비게이션 처리됨
							// Manager/Admin 타입의 경우에만 대시보드로 이동
							if(userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin){
								return navigateTo('/toc/dashboard/default');
							}
							// Owner 타입의 경우 이미 네비게이션되었으므로 return
							return;
						} else {
							// 실패 시 로그인 페이지로 이동
							return navigateTo('/toc/user/login');
						}
					}
				} else {
					// accessToken이 있으면 이미 로그인된 상태
					// 대시보드로 이동
					return navigateTo('/toc/dashboard/default');
				}
			} else {
				// 자동로그인이 비활성화되어 있으면 로그인 페이지로 이동
				return navigateTo('/toc/user/login');
			}
		}
	}


	if(to.fullPath === '/mobile'){
		// alert(isAutoLoginCheck.value);
		// alert(userToken.value);

		if(isAutoLoginCheck.value === 'true' && userToken.value){

			// 자동 로그인이 활성화되어 있고 토큰이 있으면 토큰 갱신 후 로그인 처리
			try {
				setPageLayout("non-header-footer");
				await userStore.refreshToken();
				const result = userStore.apiTokenInfo;
				if(result?.userSeq) {
					login(result.userSeq);
				}
			} catch (error) {
				console.error('자동 로그인 실패:', error);
				// 토큰 갱신 실패 시 로그인 페이지로 이동
				return navigateTo('/mobile/user/login');
			}
		} else {
			return navigateTo('/mobile/user/login');
		}
	}

	if(to.fullPath === '/mobile/user/login'){
		if(isAutoLoginCheck.value === 'true' && userToken.value){
			return navigateTo('/mobile');
		}
		
	}

	// if(to.fullPath.includes('design-toc')){
	// 	console.log('design-toc');
	// 	return
	// } else {
	// 	if(deviceType === 'isDesktop'){
	// 		if(to.fullPath === '/'){
	// 			return navigateTo('/toc/user/login');
	// 		}
	// 	}

	// 	if(to.fullPath.includes('toc')){
	// 		if(accessToken && userToken.value){
	// 			userStore.isRefresh = false;
	// 		}
	
	// 		if(ignoreURI.findIndex(v => v === to.fullPath) !== -1){
	// 			return;
	// 		}
	
	// 		if(toLoginURI.findIndex(v => v === to.fullPath) !== -1){
	// 			if(Boolean(tocAutoLogin.value) === true){
	// 				if(!accessToken){
	// 					if(!userToken.value){
	// 						// setPageLayout("toc-non-side");
	// 						return navigateTo('/toc/user/login');
	// 					} 
	// 				} 
	// 			} else {
	// 				// setPageLayout("toc-non-side");
	// 				return navigateTo('/toc/user/login');
	// 			}
	// 		}
		
	// 	} else if(to.fullPath.includes('mobile')){

	// 		// 모바일 자동 로그인 처리
	// 	if(to.fullPath === '/mobile/user/login'){
	// 		if(to.fullPath === '/' && deviceType === 'isMobile'){
	// 			return navigateTo('/mobile');
	// 		}

	// 		if(isAutoLoginCheck.value === 'true' && userToken.value){
	// 			// 자동 로그인이 활성화되어 있고 토큰이 있으면 메인 페이지로 이동
	// 			return navigateTo('/mobile');
	// 		}
	// 	} else if(to.fullPath === '/mobile'){
	// 		if(isAutoLoginCheck.value === 'true' && userToken.value){
	// 			// 자동 로그인이 활성화되어 있고 토큰이 있으면 토큰 갱신 후 로그인 처리
	// 			try {
	// 				await userStore.refreshToken();
	// 				const result = userStore.apiTokenInfo;
	// 				if(result?.userSeq) {
	// 					login(result.userSeq);
	// 				}
	// 			} catch (error) {
	// 				console.error('자동 로그인 실패:', error);
	// 				// 토큰 갱신 실패 시 로그인 페이지로 이동
	// 				return navigateTo('/mobile/user/login');
	// 			}
	// 		}
	// 	} else if(to.fullPath === '/'){
	// 		if(isAutoLoginCheck.value === 'true' && userToken.value){
	// 			// 자동 로그인이 활성화되어 있고 토큰이 있으면 토큰 갱신 후 로그인 처리
	// 			try {
	// 				await userStore.refreshToken();
	// 				const result = userStore.apiTokenInfo;
	// 				if(result?.userSeq) {
	// 					login(result.userSeq);
	// 				}
	// 			} catch (error) {
	// 				console.error('자동 로그인 실패:', error);
	// 				// 토큰 갱신 실패 시 로그인 페이지로 이동
	// 				return navigateTo('/mobile/user/login');
	// 			}
	// 		} else {
	// 			// 자동 로그인이 비활성화되어 있거나 토큰이 없으면 로그인 페이지로 이동
	// 			return navigateTo('/mobile/user/login');
	// 		}
	// 	}
	// }
	

	
	// 	// if(deviceType === 'isDesktop' && to.fullPath.includes('toc')){
	// 	// 	if(accessToken && userToken.value){
	// 	// 		userStore.isRefresh = false;
	// 	// 	}
	
	// 	// 	if(ignoreURI.findIndex(v => v === to.fullPath) !== -1){
	// 	// 		return;
	// 	// 	}
	
	// 	// 	if(toLoginURI.findIndex(v => v === to.fullPath) !== -1){
	// 	// 		if(Boolean(tocAutoLogin.value) === true){
	// 	// 			if(!accessToken){
	// 	// 				if(!userToken.value){
	// 	// 					// setPageLayout("toc-non-side");
	// 	// 					return navigateTo('/toc/user/login');
	// 	// 				} 
	// 	// 			} 
	// 	// 		} else {
	// 	// 			// setPageLayout("toc-non-side");
	// 	// 			return navigateTo('/toc/user/login');
	// 	// 		}
	// 	// 	}
		

	// 	// } 

	// 	// else if(deviceType === 'isMobile'){

			
	// 	// 	// 모바일 루트 경로 처리
	// 	// 	if(to.fullPath === '/'){
	// 	// 		if(isAutoLoginCheck.value === 'true' && userToken.value){
	// 	// 			// 자동 로그인이 활성화되어 있고 토큰이 있으면 토큰 갱신 후 로그인 처리
	// 	// 			try {
	// 	// 				await userStore.refreshToken();
	// 	// 				const result = userStore.apiTokenInfo;
	// 	// 				if(result?.userSeq) {
	// 	// 					login(result.userSeq);
	// 	// 				}
	// 	// 			} catch (error) {
	// 	// 				console.error('자동 로그인 실패:', error);
	// 	// 				// 토큰 갱신 실패 시 로그인 페이지로 이동
	// 	// 				return navigateTo('/mobile/user/login');
	// 	// 			}
	// 	// 		} else {
	// 	// 			// 자동 로그인이 비활성화되어 있거나 토큰이 없으면 로그인 페이지로 이동
	// 	// 			return navigateTo('/mobile/user/login');
	// 	// 		}
	// 	// 	}
	// 	// }

	// }

	/**
	 * TOC 자동로그인 성공 시 필요한 초기화 작업 수행
	 * @param userSeq 사용자 일련번호
	 */
	async function tocAutoLoginInit(userSeq: number) {
		try {
			/** 자동로그인 시에도 DB 최신 코드 반영을 위해 강제 재조회 */
			await commonCodeStore.init(true);
			await commonCodeStore.getCities();

			/** 라우트 리스트 가져오기 */
			// TODO: API 기능 완성 후 활성화 예정 - 현재는 router.json만 사용
			// await routeStore.getUserRouteList(userSeq);

			/** 사용자 타입에 따른 라우터 업데이트 및 네비게이션 */
			if (userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin) {
				userStore.setUserRoutePermission('admin');
				
				// 스토어 상태 업데이트 후 잠시 대기
				await nextTick();
				await new Promise(resolve => setTimeout(resolve, 100));
				
				// 라우터 업데이트
				try {
					await updateRouter();
				} catch (error) {
					console.error('라우터 업데이트 실패:', error);
				}
			} else if(userStore.getUserType === UserType.Owner){
				let getEquipList = await tocStore.getDesignTocSiteList({
					pageNo: 1,
					pageSize: 100
				}) as any;

				// 설비가 없는 경우 확인
				const hasNoEquip = (getEquipList?.singleEquipCount === 0 && getEquipList?.siteEquipCount === 0 && (!getEquipList?.equipCount || getEquipList?.equipCount === 0));
				// TODO: API 기능 완성 후 활성화 예정 - 현재는 router.json만 사용
				// const userRouteList = routeStore.userRouteList;
				// const hasNoRoutes = !userRouteList || !userRouteList.routes || userRouteList.routes.length === 0;

				if (hasNoEquip) {
					Swal.fire({
						html: `<p style="font-size: 15px;">연결된 설비가 없습니다.<br>관리자에게 문의해주세요.</p>`,
						confirmButtonColor: "#007CE1",
						confirmButtonText: "확인",
						width: "50%",
					}).then(() => {
						navigateTo('/toc/user/login');
					});
					return;
				}

				if(getEquipList?.singleEquipCount === 1 && getEquipList?.siteEquipCount === 0){
					userStore.setUserRoutePermission('equipone');
					tocStore.setSelectSiteInfo(getEquipList.content[0]);
					const equip = await equipStore.selectEquipData(getEquipList.content[0].cid);
					if (equip) {
						tocStore.setSelectEquipInfo(equip);
						
						// 스토어 상태 업데이트 후 잠시 대기
						await nextTick();
						await new Promise(resolve => setTimeout(resolve, 200));
						
						// 라우터 업데이트
						try {
							await updateRouter();
							// 라우터 업데이트 후 추가 대기 시간 확보
							await nextTick();
							await new Promise(resolve => setTimeout(resolve, 300));
						} catch (error) {
							console.error('라우터 업데이트 실패:', error);
							// 라우터 업데이트 실패 시 기본 경로로 이동
							router.replace({path: '/toc/dashboard/default'});
							return;
						}

						// 라우터 업데이트 완료 후 네비게이션
						const routeExists = await waitForRouteUpdate('dashboard-site-default-equip-equipid');
						if (routeExists) {
							await router.replace({name: 'dashboard-site-default-equip-equipid', params: {equipid: equip.cid}});
						} else {
							console.warn('라우터를 찾을 수 없어 기본 경로로 이동합니다:', 'dashboard-site-default-equip-equipid');
							try {
								await router.replace({path: '/toc/dashboard/default'});
							} catch (error) {
								console.error('기본 경로로 이동 실패:', error);
								// 최종 fallback: navigateTo 사용
								await navigateTo('/toc/dashboard/default');
							}
						}
					}
				} else if(getEquipList?.siteEquipCount === 1){
					
						console.log(getEquipList.content[0]);
						// 라우터 업데이트 완료 후 네비게이션
						if(getEquipList.content[0].engSourceKind === 'drgeo'){
							userStore.setUserRoutePermission('equipone');
							tocStore.setSelectSiteInfo(getEquipList.content[0]);
							const equip = await equipStore.selectEquipData(getEquipList.content[0].cid);
							if (equip) {
								tocStore.setSelectEquipInfo(equip);

								// 스토어 상태 업데이트 후 잠시 대기
								await nextTick();
								await new Promise(resolve => setTimeout(resolve, 200));
								
								// 라우터 업데이트
								try {
									await updateRouter();
									// 라우터 업데이트 후 추가 대기 시간 확보
									await nextTick();
									await new Promise(resolve => setTimeout(resolve, 300));
								} catch (error) {
									console.error('라우터 업데이트 실패:', error);
									// 라우터 업데이트 실패 시 기본 경로로 이동
									router.push({path: '/toc/dashboard/default'});
									return;
								}


								const routeExists = await waitForRouteUpdate('dashboard-site-default-equip-equipid');
								if (routeExists) {
									await router.push({
										name: 'dashboard-site-default-equip-equipid',
										params: { equipid: equip.cid },
										query: { dashboardVersion: 'new' },
									});
								} else {
									console.warn('라우터를 찾을 수 없어 기본 경로로 이동합니다:', 'dashboard-site-default-equip-equipid');
									try {
										await router.push({path: '/toc/dashboard/default'});
									} catch (error) {
										console.error('기본 경로로 이동 실패:', error);
										// 최종 fallback: navigateTo 사용
										await navigateTo('/toc/dashboard/default');
									}
								}
							}
						} else {
							userStore.setUserRoutePermission('siteone');
							tocStore.setSelectSiteInfo(getEquipList.content[0]);
							
							// 스토어 상태 업데이트 후 잠시 대기
							await nextTick();
							await new Promise(resolve => setTimeout(resolve, 200));
							
							// 라우터 업데이트
							try {
								await updateRouter();
								// 라우터 업데이트 후 추가 대기 시간 확보
								await nextTick();
								await new Promise(resolve => setTimeout(resolve, 300));
							} catch (error) {
								console.error('라우터 업데이트 실패:', error);
								// 라우터 업데이트 실패 시 기본 경로로 이동
								router.push({path: '/toc/dashboard/default'});
								return;
							}

							const routeExists = await waitForRouteUpdate('sites-detail-default');
							if (routeExists) {
								await router.push({name: 'sites-detail-default'})
							} else {
								console.warn('라우터를 찾을 수 없어 기본 경로로 이동합니다:', 'sites-detail-default');
								try {
									await router.push({path: '/toc/dashboard/default'});
								} catch (error) {
									console.error('기본 경로로 이동 실패:', error);
									// 최종 fallback: navigateTo 사용
									await navigateTo('/toc/dashboard/default');
								}
							}
						}
				} else if(getEquipList?.siteEquipCount > 1){
					userStore.setUserRoutePermission('siteover');
					
					// 스토어 상태 업데이트 후 잠시 대기
					await nextTick();
					await new Promise(resolve => setTimeout(resolve, 200));
					
					// 라우터 업데이트
					try {
						await updateRouter();
						// 라우터 업데이트 후 추가 대기 시간 확보
						await nextTick();
						await new Promise(resolve => setTimeout(resolve, 300));
					} catch (error) {
						console.error('라우터 업데이트 실패:', error);
					}

					// 라우터 업데이트 완료 후 네비게이션
					router.replace({path: '/toc/dashboard/default'});
				} else if(getEquipList?.siteEquipCount === 0 && getEquipList?.equipCount > 1){
					userStore.setUserRoutePermission('siteover');
					
					// 스토어 상태 업데이트 후 잠시 대기
					await nextTick();
					await new Promise(resolve => setTimeout(resolve, 200));
					
					// 라우터 업데이트
					try {
						await updateRouter();
						// 라우터 업데이트 후 추가 대기 시간 확보
						await nextTick();
						await new Promise(resolve => setTimeout(resolve, 300));
					} catch (error) {
						console.error('라우터 업데이트 실패:', error);
					}

					// 라우터 업데이트 완료 후 네비게이션
					router.replace({path: '/toc/dashboard/default'});
				} else {
					// 기본 대시보드로 이동
					router.replace({path: '/toc/dashboard/default'});
				}
			}
		} catch (error) {
			console.error('TOC 자동로그인 초기화 실패:', error);
			throw error;
		}
	}

	async function login(userSeq: number) {
		// alert(`login : ${userSeq}`);

    await commonCodeStore.getInitAllCodeMap();

		installerStore.init();


		try {
			if (userSeq) {
				/** 코드 카테고리  */
				await commonCodeStore.getCodeCategories();
				/** 모든 코드 리스트 */
				await routeStore.makeRoutes();
				await commonCodeStore.getCities();
				// await userStore.getUsers(1, 1000, 2, "owner");
				if (userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin) {
					userStore.setMobileViewType('admin');

					await equipStore.initEquipList();
					// let mapInfo = await equipStore.getEquipMapData(userStore.loginUserInfo?.userSeq as number);
					etcStore.setFirstMap(true);
					etcStore.setFirstEquipList(true);
					router.replace(`/mobile/user/${userSeq}/equipMap`);
				} else if(userStore.getUserType === UserType.Worker){
					
					if(deviceStore.device === 'isMobile' && process.env.NODE_ENV === "production"){
						//@ts-ignore
						const gpsInfo = await $invokeNative.getLocation(false);
						console.log(JSON.stringify(gpsInfo));
						if(gpsInfo.isSuccess === true){
							installerStore.setWorkerGps(gpsInfo.data.latitude, gpsInfo.data.longitude);
						} 
						
						// else if(gpsInfo.errorCode === '-1'){
						
						// 	Swal.fire({
						// 		html: `<p style="font-size: 15px;">기기의 GPS 기능이 비활성화 상태입니다.<br>GPS 기능을 활성화해주세요.</p>`,
						// 		confirmButtonColor: "#1949e9",
						// 		confirmButtonText: "확인",
						// 		width: "85%",
						// 	});
						// } else if(gpsInfo.errorCode === '0'){
						// 	Swal.fire({
						// 		html: `<p style="font-size: 15px;">GPS의 권한을 획득하지 못하였습니다.<br>정확한 작업을 위해 GPS 권한허용을 승인해주세요.</p>`,
						// 		confirmButtonColor: "#1949e9",
						// 		confirmButtonText: "확인",
						// 		width: "85%",
						// 	});
						// }
					}
					router.replace('/mobile/installer/policy/all');

				} else {
					userStore.setMobileViewType('owner');

					await siteStore.getSiteList();

					await equipStore.initEquipList();
					await equipStore.setSelectSite(equipStore.convertSiteList[0].siteName);

					etcStore.setOwnerFirstStatus(true);

					router.replace(`/mobile/user/${userSeq}/views/status`);

				}
			} else {
				router.replace("/mobile/none-contents-page");
			}
		} catch (e) {
			console.error(e);

			Swal.fire({
				icon: 'error',
				html: `오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.`,
				confirmButtonColor: "#007CE1",
				confirmButtonText: "확인",
			});
		}
	}
	
	// async function login(userSeq: number) {
	// 	try {
	// 		if (userSeq) {
	// 			/** 코드 카테고리  */
	// 			await commonCodeStore.getCodeCategories();
	// 			/** 모든 코드 리스트 */
	// 			await commonCodeStore.getInitAllCode();
	// 			await routeStore.makeRoutes();
	// 			await commonCodeStore.getCities();
	// 			// await userStore.getUsers();

	// 			if (userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin) {
	// 				let result = await equipStore.getEquipList(userSeq);
	// 				// let mapInfo = await equipStore.getEquipMapData(userStore.loginUserInfo?.userSeq as number);
	// 				etcStore.setFirstMap(true);
	// 				etcStore.setFirstEquipList(true);
	// 				// let routeName = commonCodeStore.getEngSourceName(equipStore.selectEquipInfo.engSource as string);

	// 				router.replace(`/mobile/user/${userSeq}/equipMap`);
	// 			} else {
	// 				const siteResult = await siteStore.getSiteList(userSeq);

	// 				await siteStore.selectSite(siteResult[0], userSeq);
	// 				await equipStore.getEquipList(userSeq);
	// 				// await equipStore.set
	// 				await equipStore.setSelectSite(userSeq, equipStore.convertSiteList[0].siteName);

	// 				// etcStore.setFirstMap(false);
	// 				// etcStore.setFirstEquipList(false);
	// 				etcStore.setOwnerFirstStatus(true);

	// 				router.replace(`/mobile/user/${userSeq}/views/status`);
	// 			}
	// 		} else {
	// 			router.replace("/mobile/none-contents-page");
	// 		}
	// 	} catch (e) {

	// 		// alert();
	// 		Swal.fire({
	// 			html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
	// 			confirmButtonColor: "#007CE1",
	// 			confirmButtonText: "확인",
	// 			width: "85%",
	// 		})
	// 	}
	// }
});

